import {Grid} from "@mui/material"
import React, {useContext} from "react"
import RisikoortItem from "./ListItemsManagerWidget/RisikoortItem"
import ListItemsManagerAdd from "./ListItemsManagerWidget/ListItemsManagerAdd"
import {DataContext} from "../../../context/DataContextProvider"
import {getMerkmal} from "../../../../anwendungskonfigurator/misc/widget-functions"
import _ from "lodash"

const parseAddress = (address) => ({strasse: address.street,
        hausnummer: address.hausnummer,
        postleitzahl: address.postleitzahl,
        land: address.land,
        ort: address.ort,
    })

const compareAddresses = (firstAddress, secondAddress) => {
   return _.isEqual(parseAddress(firstAddress), parseAddress(secondAddress))
}

const RisikoortWidget = ({widget}) => {
    const {getDataFromPointer} = useContext(DataContext)
    const rawRisikoortList = getDataFromPointer(getMerkmal(widget).pointer)
    const risikoortList = _.isArray(rawRisikoortList) ? rawRisikoortList : []
    const rawAddressList = getDataFromPointer(getMerkmal(widget).kommentar) ?? []
    const addressList = _.isArray(rawAddressList) && rawAddressList?.filter(adress => adress.gueltig && !risikoortList.find(risikoort => compareAddresses(risikoort, adress)))
    const onlyOneRisikoort = risikoortList.length === 1

    return (
        <Grid
            container
            spacing={1}
            p={1}
            sx={{border: "1px solid #dee2e6", backgroundColor: "#f8f9fa"}}
        >
            {risikoortList?.map(risikoort => (
                <Grid item>
                    <RisikoortItem
                        risikoort={risikoort}
                        deleteDisabled={onlyOneRisikoort}
                    />
                </Grid>
            ))}
            {addressList.length ? <Grid item>
                <ListItemsManagerAdd addressList={addressList} />
            </Grid> : <></>}
        </Grid>
    )
}

export default RisikoortWidget
